import { MoveLeft } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Button } from './ui/button';

interface NavigationBarProps {
  onBack?: () => void;
  backLabel?: string;
  stepIndicator?: string;
}

export function NavigationBar({ onBack, backLabel, stepIndicator }: NavigationBarProps) {
  const showBackButton = onBack !== undefined && backLabel !== undefined;

  if (!showBackButton && !stepIndicator) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-between">
      {showBackButton ? (
        <Button
          variant="ghost"
          type="button"
          onClick={onBack}
          className={cn(
            // Special heights/margins for focus ring display
            'active:text-hydrangea-700 my-1.5 h-9 gap-1.5 text-sm font-normal text-hydrangea-500 hover:bg-transparent focus-visible:ring-hydrangea-500'
          )}
          aria-label={`Go back to ${backLabel}`}
        >
          <MoveLeft className="size-6" aria-hidden="true" />
          <span>{backLabel}</span>
        </Button>
      ) : (
        <div />
      )}
      {stepIndicator && (
        <span className="text-base text-sm font-normal text-charcoal-500">{stepIndicator}</span>
      )}
    </div>
  );
}
